<template>

</template>

<script>
  export default {
    name: 'logout',

    mounted () {
      var slug = sessionStorage.getItem('archiveSlug')
      this.$store.dispatch('logout')
      this.$router.push(slug ? '/login/' + slug : '/login')
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Logout.vue